import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/map-pin-filled.vue
var o = {
	name: "DtIconMapPinFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--map-pin-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Map Pin Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "m6 11 .263.35v-.001l.004-.002.01-.008.036-.028.133-.105a16.107 16.107 0 0 0 1.881-1.79c1.01-1.137 2.11-2.743 2.11-4.416a4.438 4.438 0 0 0-8.874 0c0 1.673 1.1 3.28 2.11 4.416a16.107 16.107 0 0 0 2.014 1.895l.023.018.013.01.01.008.003.002h.001L6 11Zm0 0-.263.35c.156.117.37.117.526 0L6 11Zm0-7.063a1.063 1.063 0 1 1 0 2.126 1.063 1.063 0 0 1 0-2.125ZM7.938 5a1.938 1.938 0 1 0-3.876 0 1.938 1.938 0 0 0 3.875 0Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=map-pin-filled.js.map